import { PageLoader } from "@euka-mfes/bark";
import { getBaseRoute } from "@utils/route";
import { useEffect } from "react";

/**
 * ClearStoragePage purges all persisted state (sessionStorage) and redirects
 * to the app root. This is used by the OEX impersonation flow to ensure the
 * MFE loads fresh state for the newly impersonated user after the OEX callback
 * sets new session + JWT cookies.
 */
const ClearStoragePage = () => {
  useEffect(() => {
    // Clear sessionStorage to remove any cached user/course data.
    sessionStorage.clear();

    // Redirect to the app root which will bootstrap with the new user identity.
    window.location.replace(getBaseRoute());
  }, []);

  return <PageLoader overlayColor="gradeTheme.pageBg" />;
};

export default ClearStoragePage;
